import { make } from 'vuex-pathify';
import initialState from './state';

export default {
    ...make.mutations(initialState),

    INCREMENT_NEXT_EDITABLE_UID(state) {
        state.nextEditableUid += 1;
    },
};
